export const iconFontAwesomeUsersPeopleUsersBetweenLines = (
	<i className="fa-solid fa-users-between-lines"></i>
);
